import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LockInfoModule } from './lock-info/lock-info.module';
import { LockNameModule } from './lock-name/lock-name.module';
import { SuccessfulCreateLockModule } from './successful-create-lock/successful-create-lock.module';
import { AddLockComponent } from './add-lock.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [AddLockComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LockInfoModule,
    LockNameModule,
    SuccessfulCreateLockModule,
    TranslateModule
  ],
  exports: [AddLockComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class AddLockModule {}
